import { i18n } from '@/locales';
import { isRequired } from './index';
// eslint-disable-next-line import/prefer-default-export
export const createWorkerNoticeFormRule = () => ({
    /** 제목 */
    title: [
        (v) => isRequired(v) || i18n.t('form_rules.value_require'),
    ],
    /** 본문 */
    body: [
        (v) => isRequired(v) || i18n.t('form_rules.value_require'),
    ],
    /** 특정 라이더 선택 */
    workerList: [
        (v) => v.length > 0 || i18n.t('form_rules.value_require'),
    ],
});
